import { Icon } from "../../Icon";
import { IIcon } from "../../interfaces/IIcon";

export const callingCardIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="3"/><path fill="#FFF" fill-rule="nonzero" d="M47 21v21H17V21h30zm3-3H14v27h36V18zM35 38.395V39H20v-.626c-.006-1.668.066-2.62 1.986-3.064 2.104-.486 4.18-.92 3.183-2.762C22.209 27.093 24.324 24 27.5 24c3.116 0 5.282 2.977 2.334 8.548-.97 1.83 1.032 2.265 3.182 2.762 1.925.445 1.992 1.404 1.984 3.085zM44 24h-6v3h6v-3zm0 6h-6v3h6v-3zm0 6h-6v3h6v-3z"/></svg>`
);
